enum LAYOUT_TYPES {
  VERTICAL = "default",
  HORIZONTAL = "horizontal",
  MODERN = "modern",
  BOXED = "boxed",
  SEMIBOX = "semibox"
}

enum LAYOUT_CONTENT_WIDTH {
  DEFAULT = "default",
  FLUID = "fluid",
}

enum LAYOUT_MODE_TYPES {
  LIGHT = "light",
  DARK = "dark",
  DEFAULT = "default",
  BLACKWHITE = "black-white"
}

enum SIDEBAR_SIZE {
  DEFAULT = "default",
  MEDIUM = "medium",
  SMALL = "small"
}

enum SIDEBAR_COLOR {
  LIGHT = "light",
  DARK = "dark",
  BRAND = "brand",
  PURPLE = "purple",
  SKY = "sky"
}

enum LAYOUT_DIRECTION {
  LTR = "ltr",
  RTL = "rtl",
}

enum MODERN_NAVIGATION {
  DEFAULT = "default",
  FLOATING = "floating",
  BOXED = "boxed",
  PATTERN = "pattern",
}

enum DARK_MODE_CLASS {
  DEFAULT = "default",
  ZINC = "zinc",
  STONE = "stone",
  NEUTRAL = "neutral",
  GRAY = "gray"
}

enum DATA_COLORS {
  DEFAULT = "default",
  GREEN = "green",
  VIOLET = "violet",
  ORANGE = "orange",
  TEAL = "teal",
  FUCHSIA = "fuchsia",
  LIME = "lime",
  AMBER = "amber"
}

enum LAYOUT_LANGUAGES {
  ENGLISH = 'en',
  SPANISH = 'es',
  FRENCH = 'fr',
  RUSSIAN = 'ru',
  GERMAN = 'de',
  ITALIAN = 'it',
  CHINESE = 'zh',
  ARABIC = 'ar',
  TURKISH = 'tr',
  HEBREW = 'he',
  VIETNAMESE = 'vi',
  DUTCH = 'nl',
  KOREAN = 'ko',
  PORTUGUESE = 'pt',
}

export {
  LAYOUT_TYPES,
  LAYOUT_MODE_TYPES,
  LAYOUT_DIRECTION,
  LAYOUT_CONTENT_WIDTH,
  SIDEBAR_SIZE,
  SIDEBAR_COLOR,
  DATA_COLORS,
  LAYOUT_LANGUAGES,
  MODERN_NAVIGATION,
  DARK_MODE_CLASS
};
